import './styles.scss'
import {IMonthlyWeightShipped} from '../../../api/MonthlyWeightShipped/MonthlyWeightShipped.types'
import {IWidgetResponse} from '../../../api/Base/Base.types'
import {ResponsiveBar} from '@nivo/bar'
import NumberUtils from "../../../utils/number.utils";
import {Text} from "@mantine/core";
import WidgetNivoBase from "../Widget.nivo.base";

interface Props {
    data?: IWidgetResponse<IMonthlyWeightShipped>
}

function MonthlyWeightShipped({data}: Props) {
    function getData() {
        if (data) {
            return data.data.map(d => ({date: `${d.month}/${d.year}`, weight: d.totalWeight}));
        }
    }

    return (
        <div className="monthly-weight">
            <WidgetNivoBase.Bar
                title="Weight Shipped Per Month"
                data={getData()}
                keys={["weight"]}
                indexBy="date"
                axisLeftName="Weight (lbs)"
                axisBottomName="Date (MM/YYYY)"
                axisBottomRotation={-45}
                formatValue={v => NumberUtils.toShortened(v, 2)}
                tooltip={({value, color}) => (
                    <div style={{padding: 12, color, background: "#222222", borderRadius: 10}}>
                        <strong>{NumberUtils.numberWithCommas(value)} lbs</strong>
                    </div>
                )}
            />
        </div>
    )
}

export default MonthlyWeightShipped;